import { render, staticRenderFns } from "./68.vue?vue&type=template&id=5834f1f2&scoped=true&"
import script from "./68.vue?vue&type=script&lang=js&"
export * from "./68.vue?vue&type=script&lang=js&"
import style0 from "./68.vue?vue&type=style&index=0&id=5834f1f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5834f1f2",
  null
  
)

export default component.exports